import { ConfigProvider, Spin } from "antd";
import ptBR from "antd/lib/locale/pt_BR";
import { SolLoading } from "./components/SolLoading";
import { UserStorage } from "./contexts/UserContext";
import Rotas from "./rotas";

import "antd/dist/antd.less";
import "./App.css";

// Loading padrão de todos os Spin e tabelas (loading) do sistema
Spin.setDefaultIndicator(<SolLoading />);

const App = () => {
  return (
    <ConfigProvider locale={ptBR}>
      <UserStorage>
        <Rotas />
      </UserStorage>
    </ConfigProvider>
  );
};

export default App;
